import { useTheme } from 'next-themes';
import { useFunMode } from '../FunMode/useFunMode';

export const PDFViewerFun = () => {
  const { funMode } = useFunMode();
  const { theme, systemTheme } = useTheme();

  const enabled =
    funMode.enabled &&
    (theme === 'dark' || (theme === 'system' && systemTheme === 'dark'));

  if (!enabled) return null;

  return (
    <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden ">
      <img
        src={`/images/pdfbg/${funMode.background}.png`}
        alt="pdf-viewer-bg"
        className="w-full h-full object-cover opacity-70"
        style={{
          maskImage:
            'linear-gradient(225deg, rgba(0,0,0,0.9) 40%, rgba(0,0,0,0) 80%), linear-gradient(315deg, rgba(0,0,0,0.6) 30%, rgba(0,0,0,0))',
          WebkitMaskImage:
            'linear-gradient(225deg, rgba(0,0,0,0.9) 40%, rgba(0,0,0,0) 80%), linear-gradient(315deg, rgba(0,0,0,0.6) 30%, rgba(0,0,0,0))',
          maskComposite: 'intersect',
          WebkitMaskComposite: 'source-in',
        }}
      />
    </div>
  );
};
